









































import {Component, Vue} from 'vue-property-decorator';
import {Getter, Action} from 'vuex-class';
import Card from '@/components/material/Card.vue';
import DlgFileNew from '@/modules/files/_components/DlgFileNew.vue';
import DlgFileDelete from '@/modules/files/_components/DlgFileDelete.vue';
import DlgFileEdit from '@/modules/files/_components/DlgFileEdit.vue';

@Component({
  components: {
    DlgFileEdit,
    Card,
    DlgFileNew,
    DlgFileDelete,
  },
})
export default class FilesList extends Vue {
  private loading: boolean = false;

  private headers: any = [
    {
      text: 'Titel',
      align: 'left',
      value: 'title',
    },
    {
      text: 'Vorstand',
      align: 'left',
      value: 'vorstand',
    },
    {
      text: 'Kategorien',
      align: 'left',
      sortable: false,
      value: 'category',
    },
    {
      text: '',
      align: 'left',
      sortable: false,
      value: '',
    },
  ];

  private search: string = '';

  @Getter('files/all') private files!: any[];
  @Action('files/read') private readAllFiles!: any;

  private created() {
    this.loading = true;
    this.readAllFiles()
      .then(() => {
        this.loading = false;
      });
  }
}
